import { Option } from '@mm/components';
import { assertUnreachable } from '@mm/utils';
import { AutomationTemplateChannel } from '../../TemplateDefinitions';
import styles from './TemplateSharedStyles.module.css';

export const COMMON_SELECT_OPTIONS = {
  hideCount: true,
  hideClearButton: true,
  disableClickOutsideExceptions: true,
  staticDropdownPositioning: true,
  className: styles.select,
  label: '',
  placeholder: 'Selection Required',
};

export const TRIGGER_OPTIONS_BY_CHANNEL: Record<
  AutomationTemplateChannel,
  Option[]
> = {
  facebook: [
    { id: 'welcome_page', label: 'Messages me for the first time' },
    { id: 'fb_comment_guard', label: 'Comments on a Post' },
  ],
  instagram: [
    { id: 'instagram_welcomer', label: 'DMs me for the first time' },
    { id: 'instagram_comment_guard', label: 'Comments on a Post' },
    { id: 'instagram_story_reaction', label: 'Reacts to a Story' },
    { id: 'instagram_story_mention', label: 'Mentions me in a Story' },
    {
      id: 'instagram_live_comment_guard',
      label: 'Comments on my Instagram Live',
    },
  ],
  email: [],
  webchat: [
    {
      id: 'customer_chat',
      label: 'Starts a chat on my website',
    },
  ],
};

export type CollectionOption = 'email' | 'phone' | 'mailing_address';
export const COLLECTION_OPTIONS: Record<
  CollectionOption,
  Option<CollectionOption>
> = {
  email: { id: 'email', label: 'Email' },
  phone: { id: 'phone', label: 'Phone Number' },
  mailing_address: { id: 'mailing_address', label: 'Mailing Address' },
};
type QualifyingQuestionOption = 1 | 2;
export const QUALIFYING_QUESTION_OPTIONS: Option<QualifyingQuestionOption>[] = [
  { id: 1, label: '1 qualifying question' },
  { id: 2, label: '2 qualifying questions' },
];
export const NUMERIC_OPTIONS = [
  { id: 0, label: '0' },
  { id: 1, label: '1' },
  { id: 2, label: '2' },
  { id: 3, label: '3' },
  { id: 4, label: '4' },
  { id: 5, label: '5' },
  { id: 6, label: '6' },
  { id: 7, label: '7' },
  { id: 8, label: '8' },
  { id: 9, label: '9' },
  { id: 10, label: '10' },
  { id: 11, label: '11' },
  { id: 12, label: '12' },
  { id: 13, label: '13' },
  { id: 14, label: '14' },
];

export const automationChannelName = (channel: AutomationTemplateChannel) => {
  switch (channel) {
    case 'facebook':
      return 'Facebook';
    case 'instagram':
      return 'Instagram';
    case 'email':
      return 'Email';
    case 'webchat':
      return 'Web Chat';
    default:
      assertUnreachable(channel);
  }
};

export const automationChannelMessageName = (
  channel: AutomationTemplateChannel,
) => {
  switch (channel) {
    case 'facebook':
      return 'Facebook Messages';
    case 'instagram':
      return 'Instagram DMs';
    case 'email':
      return 'Emails';
    case 'webchat':
      return 'Web Chat Messages';
    default:
      assertUnreachable(channel);
  }
};
